// extracted by mini-css-extract-plugin
var _1 = "pfx-EditUserEmail-module__actions--uFwBZ";
var _2 = "#000";
var _3 = "1260px";
var _4 = "1020px";
var _5 = "668px";
var _6 = "1550px";
var _7 = "pfx-EditUserEmail-module__container--L1KUP";
var _8 = "1140px";
var _9 = "940px";
var _a = "100%";
var _b = "15px";
var _c = "620px";
var _d = "#f53535";
var _e = "rgba(0,0,0,.2)";
var _f = "rgba(255,255,255,.38)";
var _10 = ".38";
var _11 = "pfx-EditUserEmail-module__edit-container--WuqbS";
var _12 = "pfx-EditUserEmail-module__email--cGiB4";
var _13 = "pfx-EditUserEmail-module__email-container--aOY1y";
var _14 = "pfx-EditUserEmail-module__error--bhKO4";
var _15 = "rgba(255,255,255,.2)";
var _16 = "#0025ff";
var _17 = "#f60";
var _18 = "#41ead4";
var _19 = "#2cdd78";
var _1a = "#66ab23";
var _1b = "#f5f5f5";
var _1c = "#c3c3c3";
var _1d = "#ececec";
var _1e = "#252525";
var _1f = "#272727";
var _20 = "#c6c6c5";
var _21 = "#333";
var _22 = "#3c3c3c";
var _23 = "#9c9b9b";
var _24 = "#8c8c8c";
var _25 = "#6f6f6e";
var _26 = "#3c3c3b";
var _27 = "#373737";
var _28 = "#6a6a69";
var _29 = "#6f6f6f";
var _2a = "#9f9e9e";
var _2b = "#282828";
var _2c = "#828181";
var _2d = "#1d1d1d";
var _2e = "#979797";
var _2f = "#9c9b9b";
var _30 = "#a7a7a6";
var _31 = "#c6c6c5";
var _32 = "#d8d8d7";
var _33 = "#dddddc";
var _34 = "72px";
var _35 = "40px";
var _36 = "36px";
var _37 = "25px";
var _38 = "18px";
var _39 = "13px";
var _3a = "pfx-EditUserEmail-module__input--m38qF";
var _3b = "#0025ff";
var _3c = "rgba(255,255,255,.12)";
var _3d = "#6535f5";
var _3e = "2px";
var _3f = "56px";
var _40 = "56px";
var _41 = "#41ead4";
var _42 = "#f60";
var _43 = "#f83600";
var _44 = "#881f00";
var _45 = "18px";
var _46 = "15px";
var _47 = "red";
var _48 = "pfx-EditUserEmail-module__serverError--Lkork";
var _49 = "13px";
var _4a = "rgba(255,255,255,.07)";
var _4b = "#35465c";
var _4c = "#55acee";
var _4d = "#fff";
var _4e = "#ffce36";
var _4f = "#ffcd00";
var _50 = "red";
export { _1 as "actions", _2 as "black", _3 as "breakLarge", _4 as "breakMedium", _5 as "breakSmall", _6 as "breakVLarge", _7 as "container", _8 as "containerLarge", _9 as "containerMedium", _a as "containerMobile", _b as "containerPaddingMobile", _c as "containerSmall", _d as "danger", _e as "darkElement", _f as "disabled", _10 as "disabledOpacity", _11 as "editContainer", _12 as "email", _13 as "emailContainer", _14 as "error", _15 as "extraLightElement", _16 as "facebook", _17 as "google", _18 as "green", _19 as "green2", _1a as "greenColor", _1b as "grey1", _1c as "grey10", _1d as "grey2", _1e as "grey25", _1f as "grey27", _20 as "grey3", _21 as "grey33", _22 as "grey3C", _23 as "grey4", _24 as "grey41", _25 as "grey5", _26 as "grey6", _27 as "grey61", _28 as "grey6A", _29 as "grey6F", _2a as "grey7", _2b as "grey8", _2c as "grey82", _2d as "grey9", _2e as "grey97", _2f as "grey9C", _30 as "greyA7", _31 as "greyC6", _32 as "greyD8", _33 as "greyDd", _34 as "header1", _35 as "header2", _36 as "header3", _37 as "header4", _38 as "header5", _39 as "header6", _3a as "input", _3b as "klein", _3c as "lightElement", _3d as "lilac", _3e as "menuBorder", _3f as "menuHeight", _40 as "menuMobileHeight", _41 as "ocean", _42 as "orange", _43 as "orange2", _44 as "orangeDark", _45 as "paragraph", _46 as "paragraphSmall", _47 as "red", _48 as "serverError", _49 as "subHeaderSmall", _4a as "subtleLightElement", _4b as "tumblr", _4c as "twitter", _4d as "white", _4e as "yellow", _4f as "yellowDeep", _50 as "youtube" }
